import environment from '@/shared/utils/environment'
import utils from '@/shared/utils'
import xmlParser from '@/shared/utils/xml-parser'

import api from './base-services'

export default api(environment, utils, fetch, xmlParser)
